import type { FC, FormEvent, ReactNode } from 'react'

import { useState } from 'react'
import { ArrowRight, CheckCircle2, Mail } from 'lucide-react'

import { Container } from '@/components/generals/container'

export const Newsletter: FC = (): ReactNode => {
    const [email, setEmail] = useState('')
    const [submitted, setSubmitted] = useState(false)

    const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault()

        if (!email.trim()) return

        setSubmitted(true)
    }

    return (
        <section id='newsletter' className='scroll-mt-24'>
            <Container>
                <div className='overflow-hidden rounded-2xl bg-primary px-6 py-12 text-primary-foreground sm:px-12 sm:py-14'>
                    <div className='mx-auto max-w-2xl text-center'>
                        <span className='inline-grid size-12 place-items-center rounded-full bg-primary-foreground/10'>
                            <Mail className='size-6' />
                        </span>

                        <h2 className='mt-5 font-heading text-2xl font-bold tracking-tight sm:text-3xl'>
                            Get new guides in your inbox
                        </h2>

                        <p className='mt-3 text-[15px] leading-relaxed text-primary-foreground/80'>
                            Practical, evidence-based dental advice, sent occasionally, never spammy.
                            Unsubscribe anytime.
                        </p>

                        {submitted ? (
                            <div className='mt-7 inline-flex items-center gap-2 rounded-lg bg-primary-foreground/10 px-5 py-3 text-sm font-medium'>
                                <CheckCircle2 className='size-5' />
                                Thanks, you are on the list.
                            </div>
                        ) : (
                            <form
                                onSubmit={handleSubmit}
                                className='mx-auto mt-7 flex max-w-md flex-col gap-3 sm:flex-row'
                            >
                                <input
                                    type='email'
                                    required
                                    value={email}
                                    onChange={event => setEmail(event.target.value)}
                                    placeholder='you@email.com'
                                    aria-label='Email address'
                                    className='h-11 flex-1 rounded-md border-0 bg-primary-foreground px-4 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary-foreground/40'
                                />

                                <button
                                    type='submit'
                                    className='inline-flex h-11 items-center justify-center gap-1.5 rounded-md bg-sand px-5 text-sm font-semibold text-sand-foreground transition-colors hover:bg-sand/90'
                                >
                                    Subscribe
                                    <ArrowRight className='size-4' />
                                </button>
                            </form>
                        )}
                    </div>
                </div>
            </Container>
        </section>
    )
}
